// https://www.npmjs.com/package/vue3-touch-events
// https://stackoverflow.com/questions/75142660/nuxt-3-how-to-add-vue3touchevents

import Vue3TouchEvents from 'vue3-touch-events';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Vue3TouchEvents);
});
